import { useMemo } from 'react';
import { useKnowledges } from './useKnowledges';
import { useCompanyAgents } from './useCompanyAgents';
import { Agent, AgentWithAttachedKnowledge } from '../../interfaces/Agent';
import Knowledge from '../../interfaces/Knowledge';

export const useAgentsWithKnowledge = (
  userId: string | undefined,
  enabled = true
) => {
  const {
    data: agents,
    isLoading: agentsLoading,
    error: agentsError,
  } = useCompanyAgents(enabled);

  const {
    data: knowledgesData,
    isLoading: knowledgesLoading,
    error: knowledgesError,
  } = useKnowledges(userId, enabled);

  const agentsWithKnowledge = useMemo((): AgentWithAttachedKnowledge[] => {
    if (!agents || !knowledgesData?.message) {
      return [];
    }

    const knowledges = knowledgesData.message as Knowledge[];
    const knowledgesMap = new Map<string | undefined, Knowledge>(
      knowledges.map((k: Knowledge) => [k.id, k])
    );

    return agents.map((agent: Agent) => ({
      ...agent,
      attachedKnowledge: knowledgesMap.get(agent.knowledge_ids?.[0]),
    }));
  }, [agents, knowledgesData?.message]);

  return {
    data: agentsWithKnowledge,
    isLoading: agentsLoading || knowledgesLoading,
    error: agentsError || knowledgesError,
    agentsCount: agents.length,
  };
};
